/* wf-center – centrerar motivet i img[data-wf-center] via --wf-cx/--wf-cy (Wheelyshop 2026-09-12) */
(function () {
  if (window.wfCenter) return;
  var P = 'wf-center:', st = null;
  try { st = window.sessionStorage; } catch (e) {}
  function get(k) { try { return st && st.getItem(P + k); } catch (e) { return null; } }
  function put(k, v) { try { st && st.setItem(P + k, v); } catch (e) {} }
  function idle(fn) { window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 80); }
  function apply(img, v) {
    var p = v.split(',');
    img.style.setProperty('--wf-cx', p[0] + '%');
    img.style.setProperty('--wf-cy', p[1] + '%');
    img.dataset.wfCentered = '1';
  }
  function measure(img, key) {
    var src = new Image();
    src.crossOrigin = 'anonymous';
    src.onload = function () {
      var w = src.naturalWidth, h = src.naturalHeight;
      if (!w || !h) return;
      var s = Math.min(1, 96 / w), cw = Math.max(1, Math.round(w * s)), ch = Math.max(1, Math.round(h * s));
      var c = document.createElement('canvas'), ctx, d, x0 = cw, y0 = ch, x1 = -1, y1 = -1, x, y, i;
      c.width = cw; c.height = ch;
      ctx = c.getContext('2d', { willReadFrequently: true });
      try { ctx.drawImage(src, 0, 0, cw, ch); d = ctx.getImageData(0, 0, cw, ch).data; } catch (e) { return; }
      for (y = 0; y < ch; y++) for (x = 0; x < cw; x++) {
        i = (y * cw + x) * 4;
        if (d[i + 3] > 20 && !(d[i] > 245 && d[i + 1] > 245 && d[i + 2] > 245)) {
          if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
      }
      c.width = c.height = 0;
      if (x1 < 0) return;
      var cx = Math.round((cw / 2 - (x0 + x1 + 1) / 2) / cw * 1000) / 10;
      var cy = Math.round((ch / 2 - (y0 + y1 + 1) / 2) / ch * 1000) / 10;
      var v = Math.max(-25, Math.min(25, cx)) + ',' + Math.max(-25, Math.min(25, cy));
      if (key.indexOf('blob:') !== 0) put(key, v);
      apply(img, v);
    };
    /* mät på en egen liten variant (Shopify CDN: width=120) – Safari vägrar CORS-läsa en bild som redan
       cachats utan CORS, och en 120 px-fil är dessutom snabbare än att läsa in fullstor bild igen */
    src.src = small(key);
  }
  function small(u) {
    if (u.indexOf('blob:') === 0 || u.indexOf('data:') === 0) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=120');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function handle(img) {
    if (img.dataset.wfCentered) return;
    /* säkring: heron (wf-hm) frilägger sina bilder själv och byter src till blob: – rör inte dem,
       och mät aldrig blob:/data:-källor (full dekodning på huvudtråden, går inte att cacha) */
    if (img.closest && img.closest('.wf-hm')) return;
    var key = img.currentSrc || img.src, hit = key && get(key);
    if (!key || key.indexOf('blob:') === 0 || key.indexOf('data:') === 0) return;
    if (hit) { apply(img, hit); return; }
    idle(function () { if (!img.dataset.wfCentered) measure(img, key); });
  }
  function run() {
    [].forEach.call(document.querySelectorAll('img[data-wf-center]'), function (img) {
      if (img.dataset.wfCentered) return;
      if (img.complete && img.naturalWidth && (img.currentSrc || img.src)) handle(img);
      else img.addEventListener('load', function () { handle(img); }, { once: true });
    });
  }
  window.wfCenter = { run: run };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  document.addEventListener('shopify:section:load', run);
})();

/* wf-backnav (Wheelyshop 2026-10-06) – bakåtknappen till kollektions-/sökgriden (sections/wf-collection-filter.liquid).
   Laddas här eftersom sektionen redan laddar wf-center.js; gör ingenting på sidor utan #wf-grid.
   Problem: när webbläsaren inte återställer sidan ur bfcache laddas sidan om och griden ritas med 24 kort
   ("Visa fler" glöms) ⇒ den sparade scrollpositionen hamnar i SEO-/FAQ-texten under griden.
   Lösning: antal visade kort + klickat kort sparas i history.state för just den historikposten. Vid bakåt/omladdning
   klickas "Visa fler" fram till samma antal direkt när griden ritas (event wf:filter, före målning) och samma kort läggs
   på samma plats i fönstret. Upprepas vid varje omritning tills besökaren själv scrollar/klickar/trycker (max 15 s).
   bfcache-fallet påverkas inte (DOM och scroll finns kvar). */
(function () {
  if (window.wfBacknav) return;
  window.wfBacknav = 1;
  function init() {
    var grid = document.getElementById('wf-grid');
    if (!grid || !window.history || !history.replaceState) return;
    var A = null, RS = null, busy = false, done = false;
    function key() { var q = location.search.replace(/^\?/, '').split('&').filter(function (p) { return p && !/^_su_rec/.test(p); }).join('&'); return location.pathname + (q ? '?' + q : ''); }
    /* Shopify kan vid bakåt studsa via shop.app (?_su_rec=…&_su_rec_id=…, iOS efter cookie-samtycke) – URL:en jämförs utan den parametern och
       posten sparas även i sessionStorage ifall history.state inte följer med studsen */
    function ss(v) { try { if (v === undefined) { var o = JSON.parse(sessionStorage.getItem('wfFL:' + key()) || 'null'); return o && Date.now() - (o.t || 0) < 1800000 ? o : null; } sessionStorage.setItem('wfFL:' + key(), JSON.stringify(v)); } catch (e) { return null; } }
    function cards() { return grid.querySelectorAll('.wf-pc').length; }
    try {
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      var s0 = (history.state && history.state.wfFL) || ss();
      if (s0 && (nav.type === 'back_forward' || nav.type === 'reload') && s0.u === key()) RS = s0;
    } catch (e) {}
    function save(a) {
      if (busy) return;
      try {
        if (a) A = a;
        var st = {}, cur = history.state, k;
        if (cur && typeof cur === 'object') { for (k in cur) if (k !== 'wfFL') st[k] = cur[k]; }
        var rec = { u: key(), n: cards(), y: Math.round(window.pageYOffset || 0) };
        if (A && document.contains(A)) { rec.a = A.getAttribute('href'); rec.o = Math.round(A.getBoundingClientRect().top); }
        st.wfFL = rec; rec.t = Date.now(); ss(rec);
        history.replaceState(st, '');
      } catch (e) {}
    }
    /* klick på ett produktkort (inte köpknappen) – capture så att det hinner sparas före navigeringen */
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('.wf-pc__add, .wf-card__add')) return;
      var a = t.closest('#wf-grid a.wf-pc__card'); if (a) save(a);
    }, true);
    /* "Visa fler" – bubbla, alltså efter att griden fyllts på */
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('#wf-morebtn')) save(); });
    window.addEventListener('pagehide', function (e) { if (!e.persisted) save(); });
    if (!RS) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    function stop(e) { if (e && e.isTrusted === false) return; /* egna syntetiska händelser räknas inte */ done = true; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, stop, { passive: true }); });
    setTimeout(stop, 15000);
    function restore() {
      if (done || document.documentElement.classList.contains('wf-fl-ld') || !cards()) return;
      var btn = document.getElementById('wf-morebtn'), box = document.getElementById('wf-more'), g = 0, n;
      busy = true;
      try { while (btn && box && !box.hidden && (n = cards()) < RS.n && g++ < 60) { btn.click(); if (cards() === n) break; } } catch (e) {}
      busy = false;
      var y = RS.y || 0;
      if (RS.a) {
        var as = grid.querySelectorAll('a.wf-pc__card');
        for (var i = 0; i < as.length; i++) if (as[i].getAttribute('href') === RS.a) { A = as[i]; /* behåll kortet som ankare om sidan lämnas igen (framåt → bakåt) */ y = as[i].getBoundingClientRect().top + window.pageYOffset - (RS.o || 0); break; }
      }
      window.scrollTo(0, Math.max(0, Math.round(y)));
    }
    document.addEventListener('wf:filter', restore);
    restore();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

/* wf-backnav2 (Wheelyshop 2026-10-06) – bakåtskydd för listor/val som annars glöms när webbläsaren inte använder bfcache
   (sidan laddas om och börjar om från start ⇒ fel position efter "Tillbaka"):
   • reservdelsportalen (sections/vehicle-finder.liquid, #wf-results): märke/modell/kategori/sök + "Visa fler"
   • Guider-flödet (sections/wf-blogportal.liquid, [data-wf-bp]): kategori/sök + "Visa fler artiklar"
   • öppnade/stängda <details> i huvudinnehållet (t.ex. produktsidans flikar/dragspel)
   • klick i produktrekommendationer (<product-recommendations>, laddas först när de syns ⇒ sidan var för kort vid bakåt)
   • Shopifys studs via shop.app (?_su_rec=…) som annars tappar scrollpositionen helt
   Valen + klickat kort sparas i history.state för just den historikposten; vid bakåt/omladdning återskapas de och kortet läggs
   på samma plats. Avbryts när besökaren själv scrollar/klickar/trycker (max 15 s). Kollektions-/sökgriden (#wf-grid) sköts av
   wf-backnav ovan; sidor utan något av detta påverkas inte. */
(function () {
  if (window.wfBacknav2) return;
  window.wfBacknav2 = 1;
  function init() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main || document.getElementById('wf-grid') || !window.history || !history.replaceState) return;
    var res = document.getElementById('wf-results'), mk = document.getElementById('wf-make');
    var vf = !!(res && mk), bp = document.querySelector('[data-wf-bp]');
    var mo = document.getElementById('wf-model'), sq = document.getElementById('wf-search'), chips = document.getElementById('wf-chips'), csel = document.getElementById('wf-cat');
    var bq = bp && bp.querySelector('[data-wf-bp-q]'), bmore = bp && bp.querySelector('[data-wf-bp-more]');
    var dets = [].slice.call(main.querySelectorAll('details[id]')), d0 = {};
    dets.forEach(function (d) { d0[d.id] = d.open; });
    var A = null, RS = null, done = false, restoring = false, expanded = false;
    function key() { var q = location.search.replace(/^\?/, '').split('&').filter(function (p) { return p && !/^_su_rec/.test(p); }).join('&'); return location.pathname + (q ? '?' + q : ''); }
    /* Shopify kan vid bakåt studsa via shop.app (?_su_rec=…&_su_rec_id=…, iOS efter cookie-samtycke) – URL:en jämförs utan den parametern och
       posten sparas även i sessionStorage ifall history.state inte följer med studsen */
    function ss(v) { try { if (v === undefined) { var o = JSON.parse(sessionStorage.getItem('wfFL2:' + key()) || 'null'); return o && Date.now() - (o.t || 0) < 1800000 ? o : null; } sessionStorage.setItem('wfFL2:' + key(), JSON.stringify(v)); } catch (e) { return null; } }
    function ev(el, type) { try { el.dispatchEvent(new Event(type, { bubbles: true })); } catch (e) {} }
    function vfCards() { return res ? res.querySelectorAll('.wfg__card').length : 0; }
    function vfCat() { var c = chips && chips.querySelector('.wf__chip.is-active'); return c ? (c.getAttribute('data-cat') || '') : (csel ? csel.value : ''); }
    function bpCat() { var c = bp && bp.querySelector('[data-wf-bp-cat].is-active'); return c ? (c.getAttribute('data-wf-bp-cat') || '') : ''; }
    function same(h) { return [].filter.call(main.querySelectorAll('a[href]'), function (x) { return x.getAttribute('href') === h; }); }
    try {
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      var s0 = (history.state && history.state.wfFL2) || ss();
      if (s0 && (nav.type === 'back_forward' || nav.type === 'reload') && s0.u === key()) RS = s0;
    } catch (e) {}
    /* produktrekommendationer laddas först när de syns; vid bakåt hamnar sidan ofta nedanför den tomma platsen (sidan blev för kort)
       ⇒ ladda dem direkt om de ligger ovanför/i fönstret */
    try {
      if (nav.type === 'back_forward') [].forEach.call(document.querySelectorAll('product-recommendations'), function (pr) {
        if (!pr.innerHTML.trim() && typeof pr.loadRecommendations === 'function') {
          var kick = function () { if (!pr.innerHTML.trim() && pr.getBoundingClientRect().top < window.innerHeight + 400) { try { if (pr.observer) pr.observer.unobserve(pr); pr.loadRecommendations(pr.dataset.productId); } catch (e) {} return true; } };
          if (!kick()) window.addEventListener('scroll', function f() { if (kick()) window.removeEventListener('scroll', f); }, { passive: true });
        }
      });
    } catch (e) {}
    var bounced = /(^|[?&])_su_rec/.test(location.search);
    function save(a) {
      if (restoring && !done) return;
      try {
        if (a) A = a;
        var st = {}, cur = history.state, k;
        if (cur && typeof cur === 'object') { for (k in cur) if (k !== 'wfFL2') st[k] = cur[k]; }
        var rec = { u: key(), y: Math.round(window.pageYOffset || 0) }, dd = [];
        if (vf) { rec.n = vfCards(); rec.mk = mk.value || ''; rec.mo = (mo && mo.value) || ''; rec.c = vfCat(); rec.q = (sq && sq.value.trim()) || ''; var sb = document.querySelector('#wf-subchips:not([hidden]) .wf__chip.is-active'); if (sb && sb.getAttribute('data-sub')) rec.s = sb.getAttribute('data-sub'); }
        if (bp) { rec.e = expanded ? 1 : 0; rec.c = bpCat(); rec.q = (bq && bq.value.trim()) || ''; }
        dets.forEach(function (d) { if (document.contains(d) && d.open !== d0[d.id] && dd.length < 30) dd.push([d.id, d.open ? 1 : 0]); });
        if (dd.length) rec.d = dd;
        if (A && document.contains(A)) { rec.a = A.getAttribute('href'); rec.i = Math.max(0, same(rec.a).indexOf(A)); rec.o = Math.round(A.getBoundingClientRect().top); if (A.closest('product-recommendations')) rec.r = 1; }
        st.wfFL2 = rec; rec.t = Date.now(); ss(rec);
        history.replaceState(st, '');
      } catch (e) {}
    }
    main.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('.wfg__btn')) return;
      var a = t.closest('a[href]'); if (a) save(a);
    }, true);
    document.addEventListener('click', function (e) { var a = e.target && e.target.closest && e.target.closest('#wf-qv a[href]'); if (a) save(a); }, true);
    if (bmore) bmore.addEventListener('click', function () { expanded = true; });
    window.addEventListener('pagehide', function (e) { if (!e.persisted) save(); });
    if (!RS || !(vf || bp || RS.d || RS.r || bounced)) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    restoring = true;
    function stop(e) { if (e && e.isTrusted === false) return; /* egna syntetiska händelser räknas inte */ done = true; restoring = false; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (n) { window.addEventListener(n, stop, { passive: true }); });
    setTimeout(stop, 15000);
    function place() {
      var y = RS.y || 0, el = null;
      if (RS.a) {
        var as = same(RS.a).filter(function (x) { return x.getClientRects().length; });
        el = as[RS.i || 0] || as[0];
        if (el) { A = el; /* behåll kortet som ankare om sidan lämnas igen (framåt → bakåt) */ y = el.getBoundingClientRect().top + window.pageYOffset - (RS.o || 0); }
      }
      window.scrollTo(0, Math.max(0, Math.round(y)));
      return !RS.a || !!el;
    }
    try { (RS.d || []).forEach(function (p) { var d = document.getElementById(p[0]); if (d && d.tagName === 'DETAILS') d.open = !!p[1]; }); } catch (e) {}
    if (!vf) {
      try {
        if (bp && RS.c) { var cb = bp.querySelector('[data-wf-bp-cat="' + RS.c.replace(/["\\]/g, '') + '"]'); if (cb) cb.click(); }
        if (bp && RS.q && bq) { bq.value = RS.q; ev(bq, 'input'); }
        if (bp && RS.e && bmore) { bmore.click(); if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); }
      } catch (e) {}
      /* upprepa tills kortet finns (t.ex. produktrekommendationer som hämtas först när de syns) och ligger still */
      var t1 = Date.now(), found = 0;
      (function tick2() {
        if (done) { restoring = false; return; }
        if (place()) { if (!found) found = Date.now(); else if (Date.now() - found > 1200) { done = true; restoring = false; return; } }
        if (Date.now() - t1 > 10000) { done = true; restoring = false; return; }
        setTimeout(tick2, 150);
      })();
      return;
    }
    /* reservdelsportalen: listan hämtas asynkront */
    try {
      if (RS.q && sq) {
        sq.value = RS.q;
        sq.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true, cancelable: true }));
      } else if (RS.mk || RS.mo || RS.c || mk.value) {
        if (RS.mk || mk.value) { mk.value = RS.mk || ''; ev(mk, 'change'); }
        if (RS.mo && mo) { mo.value = RS.mo; ev(mo, 'change'); }
        if (RS.c) {
          var ch = chips && chips.querySelector('.wf__chip[data-cat="' + RS.c.replace(/["\\]/g, '') + '"]');
          if (ch) ch.click(); else if (csel) { csel.value = RS.c; ev(csel, 'change'); }
        }
        /* underkategori (rad 2, #wf-subchips) */
        if (RS.s) { var sc = document.querySelector('#wf-subchips .wf__chip[data-sub="' + RS.s.replace(/["\\]/g, '') + '"]'); if (sc) sc.click(); }
      }
    } catch (e) {}
    var placedAt = 0, guard = 0;
    (function tick() {
      if (done || guard++ > 300) { restoring = false; return; }
      var btn = document.getElementById('wf-morebtn'), box = document.getElementById('wf-more'), n = vfCards();
      if (n && !res.querySelector('.wf__loading')) {
        if (n < (RS.n || 0) && btn && box && !box.hidden) { if (!btn.disabled) btn.click(); placedAt = 0; }
        else {
          place();
          if (!placedAt) placedAt = Date.now();
          else if (Date.now() - placedAt > 1200) { done = true; restoring = false; return; }
        }
      }
      setTimeout(tick, 100);
    })();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
